<template>
  <section class="july-sale">
    <div class="july-sale__content">
      <h1 class="july-sale__title">Subscribe & Save</h1>
      <div class="july-sale__intro-wrapper">
        <div class="july-sale__description">
          Choose training that helps you achieve your career goals. Save on certifications & prep
          now!
        </div>
        <div class="july-sale__link-wrapper">
          <a
            class="btn btn--primary btn--full-mobile"
            href="https://learn.ine.com/promo/july-subscribe-and-save"
            target="_blank"
            rel="noopener noreferrer"
          >
            Shop Savings
          </a>
        </div>
      </div>
    </div>
    <div class="july-sale__icon">
      <div class="july-sale__icon-logo-wrapper">
        <img :src="JulySaleImg" alt="July Sale Promo" class="july-sale__icon-logo" />
      </div>
    </div>
  </section>
</template>

<script>
import { routesRules } from '@/helpers/mixins'
import JulySaleLogoPng from '@/assets/images/hero-section/july-sale/july-sale-logo.png'

export default {
  name: 'JulySaleHeroSection',
  mixins: [routesRules],
  data() {
    return {
      JulySaleImg: JulySaleLogoPng,
    }
  },
}
</script>

<style lang="scss" scoped>
.july-sale {
  width: 100%;
  max-width: 1120px;
  color: var(--white);
  @include font-book;
  display: flex;
  flex-flow: column-reverse;
  align-items: center;
  position: relative;
  padding: 0 10px 10px;
  @include mobile {
    padding: 0 20px 0;
    flex-flow: row;
  }
  @include desktop {
    flex-flow: row;
    margin: auto;
    padding: 50px 0 40px 0;
  }
  &__title {
    color: var(--white);
    @include font-medium;
    font-size: rem(35px);
    font-style: normal;
    font-weight: 900;
    line-height: rem(37px);
    margin: 0;
    @include mobile {
      font-size: rem(40px);
    }
    @include desktop {
      font-size: rem(54px);
      line-height: rem(50px);
    }
  }
  &__intro {
    font-size: rem(17px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(26px);
    margin-top: 24px;
    @include desktop {
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__description {
    color: var(--light-blue-gray);
    font-size: rem(17px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(26px);
    width: 100%;
    @include mobile {
      width: 90%;
    }
    @include desktop {
      width: 85%;
      font-size: rem(24px);
      line-height: rem(32px);
    }
  }
  &__content {
    display: flex;
    flex-flow: column;
    gap: 20px;
  }
  &__icon {
    position: relative;
    &-logo {
      width: 100%;
    }
    &-logo-wrapper {
      display: flex;
      justify-content: center;
      @include mobile {
        width: 300px;
        height: unset;
      }
      @include desktop {
        width: 515px;
        height: 440px;
      }
    }
  }
  &__link-wrapper {
    width: 100%;
    margin-top: 20px;
    @include tablet {
      margin-top: 30px;
    }
  }
}
</style>
